import { useState, useEffect } from 'react'
import { Product } from '../types/product'
import { CartItem } from '../types/cart'
import { ApiService } from '../services/api'

interface UseRecommendedProductsReturn {
  recommendedProducts: Product[]
  loading: boolean
  error: string | null
}

export const useRecommendedProducts = (
  cartItems: CartItem[],
  limit: number = 4,
): UseRecommendedProductsReturn => {
  const [recommendedProducts, setRecommendedProducts] = useState<Product[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchRecommendedProducts = async () => {
      if (cartItems.length === 0) {
        setRecommendedProducts([])
        return
      }

      setLoading(true)
      setError(null)

      try {
        // Отримуємо унікальні категорії з корзини
        const categories = Array.from(
          new Set(
            cartItems.map(
              item => item.meta_data?.find((m: any) => m.key === 'category')?.value || 'coffee',
            ),
          ),
        )

        // Отримуємо рекомендовані товари для кожної категорії
        const allRecommended: Product[] = []

        for (const category of categories) {
          try {
            const products = await ApiService.getProductsByCategory(
              category,
              Math.ceil(limit / categories.length),
            )
            allRecommended.push(...products)
          } catch (categoryError) {
            // Failed to fetch recommendations for category
          }
        }

        // Перемішуємо та обмежуємо кількість
        const shuffled = allRecommended.sort(() => Math.random() - 0.5)
        setRecommendedProducts(shuffled.slice(0, limit))
      } catch (err) {
        setError('Помилка завантаження рекомендацій')
        // Error fetching recommended products
      } finally {
        setLoading(false)
      }
    }

    fetchRecommendedProducts()
  }, [cartItems, limit])

  return {
    recommendedProducts,
    loading,
    error,
  }
}
